import Local from './Local';

export default Local;
